import * as React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import Layout from './src/components/Layout';
import { fontConfig } from './src/config/fonts';

// Initialize fonts and styles with both preload and stylesheet
export const onClientEntry = () => {
  // Add preload link
  const preloadLink = document.createElement('link');
  const fontUrl = `${fontConfig.api}/css?family=${fontConfig.families.join('|')}&display=swap`;
  preloadLink.href = fontUrl;
  preloadLink.rel = 'preload';
  preloadLink.as = 'style';
  document.head.appendChild(preloadLink);

  // Add stylesheet link
  const stylesheetLink = document.createElement('link');
  stylesheetLink.href = fontUrl;
  stylesheetLink.rel = 'stylesheet';
  document.head.appendChild(stylesheetLink);
};

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};
